import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors, designTokens } from "theme";

export const styles = (theme: Theme) => {
	return {
		root: {
		},
		title: {
			fontSize: theme.typography.h3.fontSize,
			fontWeight: theme.typography.h3.fontWeight,
			fontFamily: theme.typography.fontFamily,
			color: theme.palette.custom.textPrimary,
		},
		newButtonAction: {
			marginTop: 0,
		},
		reactivateButtonLabel: {
			textTransform: "none",
		},
		text: {
			paddingLeft: 5,
		},
		activeChip: {
			color: designTokens.colors.successDark,
			backgroundColor: designTokens.colors.successLight,
			fontSize: "1rem",
		},
		inactiveChip: {
			color: "black",
			backgroundColor: "#e0e0e0",
			fontSize: "1rem",
		},
		tagChip: {
			margin: 4,
		},
		addTagChip: {
			margin: 4,
			width: 34,
			color: "#616161",
		},
		sectionHeader: {
			fontWeight: 600,
			marginBottom: theme.spacing(0.5),
		},
		fieldLabel: {
			fontSize: "0.8rem",
			color: theme.palette.text.secondary,
			marginBottom: 2,
		},
	} satisfies Record<string, CSSObject>;
};

